import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-list-action-buttons',
  imports: [CommonModule,ButtonComponent],
  templateUrl: './list-action-buttons.component.html',
  styleUrl: './list-action-buttons.component.css'
})
export class ListActionButtonsComponent {
 params: any;
  buttons: any[] = []

  show_dash: boolean = false


  agInit(params: any): void {
    this.params = params;
    this.buttons = this.params.actions(params.data)
  }

  refresh(params: any): boolean {
    this.params = params;
    this.buttons = this.params.actions(params.data)
    return true;
  }

  async perform_action(button: any, event: any) {
    console.log('perform_action called', button?.text, 'disabled:', button?.disabled);
    if (button.disabled) return;
    try {
      console.log('calling button.function...');
      await button.function(this.params.data, this.params.node?.rowIndex, this.params, button, event);
      this.params.api?.refreshCells({
        rowNodes: [this.params.node],
        force: true,
      });
    } catch (error) {
      console.error('Action error:', error);
    }
  }
}
